module.exports = __webpack_public_path__ + "img/tick_icon.1d2c0f0a.svg";